import { Reducer } from "redux";

import { ResetPasswordDispatchTypes } from "../models/dispatchTypes/MyAccount";
import { ResetPasswordActionDispatchTypes } from "../constants/MyAccount";
import { ResetPasswordResponse } from "../models/api/MyAccount";

const initialState: ResetPasswordResponse = {
  loading: false,
  response: false,
  error: null,
};

const ResetPasswordReducer: Reducer<ResetPasswordResponse, ResetPasswordDispatchTypes> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case ResetPasswordActionDispatchTypes.RESET_PASSWORD_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ResetPasswordActionDispatchTypes.RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case ResetPasswordActionDispatchTypes.RESET_PASSWORD_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case ResetPasswordActionDispatchTypes.RESET_PASSWORD_RESET: {
      return initialState;
    }
  }
  return state;
};

export default ResetPasswordReducer;
